import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { SidebarNavLink, SidebarWrapper } from '@components';
import { GlobalContext } from '@contexts';
import { LayersIcon, ListIcon, SettingsIcon, UsersIcon } from '@svgs';

import { SidebarSearch } from '../SidebarSearch/SidebarSearch.jsx';

export const MainSidebar = () => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  return (
    <SidebarWrapper>
      <div className="sb-sidebar-nav">
        <SidebarSearch />
        <ul>
          <SidebarNavLink to={`/dashboard/projects`}>
            <LayersIcon />
            Projects
          </SidebarNavLink>
          <SidebarNavLink to={`/dashboard/auditLog`}>
            <ListIcon />
            Audit Log
          </SidebarNavLink>
        </ul>
      </div>
      <ul className="sb-sidebar-footer">
        <SidebarNavLink to={`/dashboard/settings/account`}>
          <SettingsIcon />
          Account settings
        </SidebarNavLink>
        {globals.visible.usersView && (
          <>
            <SidebarNavLink to={`/dashboard/users`}>
              <UsersIcon />
              Users
            </SidebarNavLink>
          </>
        )}
      </ul>
    </SidebarWrapper>
  );
};
